import React, { useEffect, useState } from "react";
import VirtualTable from "../../ui/VirtualTable";
import Nav from "../../ui/Nav";
import ViewFileSearch from "./ViewFileSearch";
import { ROUTES } from "../../utils/Routes";
import { createModal } from "../../hooks/createModal";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
import { showError, showMessage } from "../../ui/Message";
export default function ViewFile(props) {

    const { route = "", callback = () => { }, text = "" } = props;

    const strToArr = (inputString) => {
        const lines = inputString.split('\n');
        const array = [];
        lines.forEach((line, index) => {
            array.push({ line: line, index: index });
        });
        return array;
    }

    const data = strToArr(text);

    const [selected, setSelected] = useState(data[0] || {});
    const [searchObj, setSearchObj] = useState({
        term: "",
        direction: "T",
    })

    const columns = [
        { key: "line", title: <>Text</>, align: "left", width: 500 }
    ]

    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const nextIndex = data.findIndex(item => item?.index == selected?.index) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };

    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.index == selected?.index) - _rows;
        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const nav = [
        { text: "AgainSrch", key: KBD.A, action: () => againSearch() },
        { text: "Prt" },
        { text: "Search", key: KBD.S, action: () => showSearch() },
        { text: "Zret" },
    ]

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => callback() },
            { key: KBD.PAGE_UP, action: (e) => { } }
        ];
        const cleanup = listen(route, actions.concat(nav), (e) => { }, [KBD.ESCAPE, KBD.PAGE_UP], [], [KBD.CTRL_C, KBD.CTRL_V]);
        return cleanup;
    }, [selected]);

    const matches = (term, line) => {
        if(!term){
            return "";
        }
        return line.toLowerCase().includes(term.toLowerCase());
    }

    const search = (start, end, step, term) => {
        for (let i = start; i !== end; i += step) {
            if (matches(term, data[i].line)) {
                return i;
            }
        }
        showError({error : "Not found."});
        return;
    }

    const againSearch = () => {
        findInArray(searchObj, selected)
    }

    const findInArray = (_obj, selected) => {

        setSearchObj(_obj);
        const { term = "", direction = "" } = _obj;
        const index = selected?.index || -1;
        let _ret = "";

        switch (direction) {
            case 'T': // Top to bottom
                _ret = search(0, data.length, 1, term);
                break;
            case 'B': // Bottom to top
                _ret = search(data.length - 1, -1, -1, term);
                break;
            case 'U': // Upward from current index
                _ret = search(index - 1, -1, -1, term);
                break;
            case 'D': // Downward from current index
                _ret = search(index + 1, data.length, 1, term);
                break;
            default:
                break;
        }
        if(_ret > -1){
            setSelected(data[_ret])
        } else {
            showError({error : "Not found."})
        }
    }

    const showSearch = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.VIEW_FILE_SEARCH;
        createModal({
            component: <ViewFileSearch searchObj={searchObj} route={ROUTES.RECONCILIATION.VIEW_FILE_SEARCH} />, title: "Search", closable: true, callback: (_r) => {
                if (_r) {
                    findInArray(_r, selected);
                }
                window.bm_state.value = route;
            }
        })
    }

    return (
        <>
            <div className="shim" /><div className="shim" />
            <VirtualTable
                onWheel={(e) => (e.deltaY > 0) ? next() : prev()}
                next={next}
                prev={prev}
                row_key={"index"}
                current={selected}
                data={data}
                columns={columns}
                width={500}
                scrollbar
                offset={400}
                route={route}
            />
            <div className="shim" />
            <Nav nav={nav} />
        </>
    )
}